var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"md-testimonials md-testimonials-bg text-center px-4",attrs:{"id":_vm.testimonials.id}},[_c('h2',{staticClass:"text-light"},[_vm._v(_vm._s(_vm.testimonials.title))]),_c('CarouselTestimonials',{staticClass:"md-testimonials-carousel",attrs:{"slides":_vm.testimonials.customers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }